"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkerRequest = void 0;
var types_1 = require("../../types");
var response_1 = require("./response");
var WorkerRequest = /** @class */ (function () {
    function WorkerRequest(worker) {
        var _this = this;
        this.worker = null;
        this.postMessage = function (payload) {
            if (_this.worker) {
                return _this.worker.postMessage(payload);
            }
        };
        this.pushWebLog = function (payload) {
            return _this.postMessage({
                type: types_1.WorkerRequestName.PushWebLog,
                payload: payload,
            });
        };
        this.pushHeartBeat = function (payload) {
            return _this.postMessage({
                type: types_1.WorkerRequestName.PushHeartBeat,
                payload: payload,
            });
        };
        this.defineMetadata = function (payload) {
            return _this.postMessage({
                type: types_1.WorkerRequestName.DefineMetadata,
                payload: payload,
            });
        };
        this.setConfig = function (payload) {
            return _this.postMessage({
                type: types_1.WorkerRequestName.SetConfig,
                payload: payload,
            });
        };
        this.setInterval = function (payload) {
            return _this.postMessage({
                type: types_1.WorkerRequestName.SetInterval,
                payload: payload,
            });
        };
        this.onGetChecksum = function (payload) {
            return _this.postMessage({
                type: types_1.WorkerRequestName.OnGetCheckSum,
                payload: payload,
            });
        };
        this.getResponse = function () {
            return new response_1.WorkerResponse(_this.worker, _this);
        };
        this.worker = worker;
    }
    return WorkerRequest;
}());
exports.WorkerRequest = WorkerRequest;
